import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=a431986c&lang=css"
import "./App.vue?vue&type=style&index=1&id=a431986c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2827775840/src/entratafarmstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a431986c"]])

export default __exports__